import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../';
import { ErrorHandlerService } from '../../services';
import { Data } from '../../helpers';
import { Observable } from 'rxjs/Rx';
import * as moment from 'moment';
import { DateTimeConverstionService } from '../../services/index';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(dashboardService, errorHandlerService, router, data, timeZoneConverstionService) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.data = data;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.subscriptions = [];
        this.subscriptionsInverval = [];
        this.myRating = [];
        this.invtReq = { requestFrom: {}, requestTo: {} };
        this.user = { noOfRatingStars: '' };
        this.sgstFriends = [];
        this.profileVisits = [];
        this.topCourses = [];
        this.hotTopics = [];
        this.networkUpdates = [];
        this.searchfname = "";
        this.searchlname = "";
        this.ts = new Date();
        this.profile = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.profilePercentage = {};
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.inviteemail = "";
        this.showErrorMessages = [];
        this.openStep2Popup = false;
        this.showErrorModalDialog = false;
        this.showErrorMessageTitle = "Error !!";
        this.showErrorPopupWidthInPercentage = "20%";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.isValidationError = true;
        this.countryId = null;
        this.city = "";
        if (localStorage.getItem('googleRegcourse')) {
            this.router.navigateByUrl('/dashboard/viewsession?sessionId=' + localStorage.getItem('googleRegcourse'));
            localStorage.removeItem('googleRegcourse');
        }
    }
    HomeComponent.prototype.editDisplay = function (suggestedFriend) {
        if (suggestedFriend.isInvitatonRequestSent) {
            return "block";
        }
        else {
            return "none";
        }
    };
    HomeComponent.prototype.navigateWithData = function (url, param) {
        this.data.storage = {
            myconnection: {
                userid: param
            }
        };
        this.router.navigate([url]);
    };
    HomeComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    HomeComponent.prototype.updateUser = function (e) {
        var _this = this;
        if (e) {
            var userSubscription = this.dashboardService.userSummary1().subscribe(function (data) {
                _this.user = data;
                console.log('userdata1' + data.status);
                console.log(data);
                _this.myRating = Array(data.noOfRatingStars);
                console.log('myRating');
                console.log(_this.myRating);
                _this.openStep2Popup = false;
            }, function (error) {
                _this.openStep2Popup = false;
                _this.handleError(error);
            });
            this.subscriptions.push(userSubscription);
        }
        else {
            this.openStep2Popup = false;
        }
    };
    HomeComponent.prototype.convertMonth = function (mon) {
        var month = '01';
        switch (mon) {
            case 'January':
                month = '01';
                break;
            case 'February':
                month = '02';
                break;
            case 'March':
                month = '03';
                break;
            case 'April':
                month = '04';
                break;
            case 'May':
                month = '05';
                break;
            case 'June':
                month = '06';
                break;
            case 'July':
                month = '07';
                break;
            case 'August':
                month = '08';
                break;
            case 'September':
                month = '09';
                break;
            case 'October':
                month = '10';
                break;
            case 'November':
                month = '11';
                break;
            case 'December':
                month = '12';
                break;
        }
        return month;
    };
    HomeComponent.prototype.closeErrorPopup = function () {
        console.log("After closing Error Popup");
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [];
    };
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.timezone = localStorage.getItem('timezone');
        if (localStorage.getItem('timezone')) {
            this.timezone = localStorage.getItem('timezone');
        }
        if (this.timezone) {
            this.timeZonechange(this.timezone);
        }
        var s1 = this.dashboardService.userSummary1().subscribe(function (data) {
            _this.user = data;
            if (data.countryId != null)
                _this.countryId = data.countryId;
            if (data.city != null)
                _this.city = data.city;
            console.log('userdata1' + data.status);
            console.log(data);
            _this.myRating = Array(data.noOfRatingStars);
            console.log('myRating');
            console.log(_this.myRating);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        var s2 = this.dashboardService.profilePercentage().subscribe(function (data) {
            console.log(data);
            _this.profilePercentage = data;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
        console.log(this.subscriptions);
        this.recuring();
        var s3 = Observable.interval(500 * 60).subscribe(function (x) {
            if (_this.router.url === '/dashboard/home') {
                _this.recuring();
            }
        });
        this.subscriptions.push(s3);
        this.subscriptionsInverval.push(s3);
        window.scrollTo(0, 0);
    };
    HomeComponent.prototype.timeZonechange = function (data) {
        var _this = this;
        this.topCourses.forEach(function (element) {
            element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseStartDTime);
            element.timeZoneConverted = _this.timezone;
            element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseEndDTime);
            element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseStartDTime);
            element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseEndDTime);
        });
        localStorage.setItem('timezone', data);
    };
    HomeComponent.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            var setdate = moment(datetime.toString(), 'YYYY-MM-DD HH:mm Z');
            return setdate.tz(timezone).format('MM/DD/YYYY');
        }
        else {
            var setdate = moment(datetime + '+00:00'.toString(), 'HH:mmZ');
            return setdate.tz(timezone).format('HH:mm');
        }
    };
    HomeComponent.prototype.recuring = function () {
        var _this = this;
        var s4 = this.dashboardService.pollProfileVisits().subscribe(function (res) { _this.profileVisits = res; console.log('profileVisits'); console.log(_this.profileVisits); }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
                _this.subscriptionsInverval.forEach(function (e) {
                    e.unsubscribe();
                });
            }
        });
        this.subscriptions.push(s4);
        var s5 = this.dashboardService.pollTopCourses().subscribe(function (res) { _this.topCourses = res; console.log('courses'); console.log(_this.topCourses); _this.timeZonechange(_this.timezone); }, function (error) {
            _this.handleError(error);
            _this.subscriptionsInverval.forEach(function (e) {
                e.unsubscribe();
            });
        });
        this.subscriptions.push(s5);
        var s6 = this.dashboardService.pollSuggestFriends().subscribe(function (res) {
            _this.sgstFriends = [];
            console.log('sugg');
            console.log(res);
            res.forEach(function (element) {
                element.status = false;
                _this.sgstFriends.push(element);
            });
        }, function (error) {
            _this.handleError(error);
            _this.subscriptionsInverval.forEach(function (e) {
                e.unsubscribe();
            });
        });
        this.subscriptions.push(s6);
        var s7 = this.dashboardService.pollNetworkUpdates().subscribe(function (res) { _this.networkUpdates = res; console.log('networkUpdates'); console.log(_this.networkUpdates); }, function (error) {
            _this.handleError(error);
            _this.subscriptionsInverval.forEach(function (e) {
                e.unsubscribe();
            });
        });
        this.subscriptions.push(s7);
        var s8 = this.dashboardService.pollHotTopics().subscribe(function (res) { _this.hotTopics = res; console.log(_this.hotTopics); }, function (error) {
            _this.handleError(error);
            _this.subscriptionsInverval.forEach(function (e) {
                e.unsubscribe();
            });
        });
        this.subscriptions.push(s8);
    };
    HomeComponent.prototype.loadmore = function () {
        var _this = this;
        console.log('loadmore');
        var s10 = this.dashboardService.networkUpdatesLoadMore().subscribe(function (res) {
            res.forEach(function (element) {
                _this.networkUpdates.push(element);
            });
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s10);
    };
    HomeComponent.prototype.sendInvitationForProfileVisit = function (id, profleVistEntry) {
        var _this = this;
        this.invtReq.requestFrom.userDetailsId = this.user.userDetailsId;
        this.invtReq.requestTo.userDetailsId = id;
        this.invtReq.userRequestText = "Invitation Request sent by User Id " + this.user.userDetailsId + " to User Id " + id + ". Sent by REST Service.";
        this.invtReq.userRequestType = "INVITATION_REQUEST";
        var s11 = this.dashboardService.sendInvitationReq(this.invtReq).subscribe(function (res) {
            _this.createInfoAlert("Invitation Request Sent Successfully to user's Uvsity Inbox!!");
            profleVistEntry.invitationAction.invitationAction = 'WAITING_FOR_RESPONSE';
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s11);
    };
    HomeComponent.prototype.sendInvitationForSuggestedFriend = function (id, suggestedFriend) {
        var _this = this;
        this.invtReq.requestFrom.userDetailsId = this.user.userDetailsId;
        this.invtReq.requestTo.userDetailsId = id;
        this.invtReq.userRequestText = "Invitation Request sent by User Id " + this.user.userDetailsId + " to User Id " + id + ". Sent by REST Service.";
        this.invtReq.userRequestType = "INVITATION_REQUEST";
        var s11 = this.dashboardService.sendInvitationReq(this.invtReq).subscribe(function (res) {
            _this.createInfoAlert("Invitation Request Sent Successfully to user's Uvsity Inbox!!");
            suggestedFriend.isInvitatonRequestSent = true;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s11);
    };
    HomeComponent.prototype.inviteEmail = function () {
        var _this = this;
        var s12 = this.dashboardService.inviteEmail(this.inviteemail).subscribe(function (res) {
            _this.inviteemail = '';
            _this.createInfoAlert("Your Invitation request sent successfully. Thanks for inviting your friends. Go to Add Connection to invite more");
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s12);
    };
    HomeComponent.prototype.acceptInvite = function (invitationRequestId) {
        var _this = this;
        var s14 = this.dashboardService.connAccept(invitationRequestId).subscribe(function (data) {
            _this.recuring();
            _this.createInfoAlert("Invitation Request Accepted !!");
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s14);
    };
    HomeComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = { isInfo: true, infoMessage: alert, url: "not required" };
        this.handleError(infoAlert);
    };
    HomeComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>");
        console.log(error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return HomeComponent;
}());
export { HomeComponent };
//# sourceMappingURL=home.component.js.map